import { createSelector } from 'reselect';

const selectBatchLogs = (state: any) => state.batchLogs;


export const selectBatchLogsCurrentItem = createSelector([selectBatchLogs], (batchLogs) => batchLogs.current);

export const selectBatchLogsListItems = createSelector([selectBatchLogs], (batchLogs) => batchLogs.list);

export const selectBatchLogsItemById = (itemId: any) =>
    createSelector(selectBatchLogsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBatchLogsCreatedItem = createSelector([selectBatchLogs], (batchLogs) => batchLogs.create);

export const selectBatchLogsUpdatedItem = createSelector([selectBatchLogs], (batchLogs) => batchLogs.update);

export const selectBatchLogsReadItem = createSelector([selectBatchLogs], (batchLogs) => batchLogs.read);

export const selectDeletedItem = createSelector([selectBatchLogs], (batchLogs) => batchLogs.delete);

export const selectBatchLogsSearchedItems = createSelector([selectBatchLogs], (batchLogs) => batchLogs.search);

export const selectBatchLogsItemsCount = createSelector([selectBatchLogs], (batchLogs) => batchLogs.count);

export const selectBatchLogsItemsFilter = createSelector([selectBatchLogs], (batchLogs) => batchLogs.filter);